// extracted by mini-css-extract-plugin
export default {"chevron":"G9xaWZ2ZZ8zGw7rc4Z9x","icon":"SJjVSB0f1RdO1gEWkiOU"};